/**
 * @file Album Purchased Custom Prints filter actions.
 */

export const UPDATE_FILTER = 'album-purchased-custom-prints/UPDATE_FILTER';
export const RESET_FILTER = 'album-purchased-custom-prints/RESET_FILTER';

export const updateFilter = filter => {
  return { type: UPDATE_FILTER, filter };
};

export const resetFilter = () => {
  return { type: RESET_FILTER };
};
